//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line no-unused-vars
import moment from 'moment';

import { BTooltip } from 'bootstrap-vue';

export default {
  components: {
    BTooltip,
  },

  props: {
    event: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      screenWidth: window.innerWidth,
    };
  },

  methods: {
    handleOpenDialog() {
      this.isOpen = !this.isOpen;
    },

    formatEventDate(date) {
      return moment(date).format('MMMM Do YYYY');
    },

    formatRegistrationDate(date) {
      return moment(date, 'YYYYMMDD').fromNow();
    },
    onResize() {
      this.screenWidth = window.innerWidth;
    },

  },

  created() {
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    leaderboardLink() {
      return `https://www.pwrlab.com/distributed-event/${this.event.slug}/leaderboard`;
    },
    eventLoginLink() {
      return `https://www.pwrlab.com/distributed-event/${this.event.slug}/sign-in`;
    },
    isMobileWidth() {
      return this.screenWidth < 435;
    },
  },
};
